import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "react-json-pretty/themes/monikai.css";
import ImageWithBorders from "./PdfImageVewer";
import "../OtpValidation/otpVal.scss";

export default function PdfViewer({
  isOpenModal,
  handleClose,
  imageLink,
  coordinates,
}) {
  const coords = JSON.parse(coordinates);

  return (
    <div className="dialog-wrap">
      <Dialog
        open={isOpenModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={false}
        maxHeight={false}
        className="pdf-dialog"
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent maxWidth={false} id="pdfDialogContent" maxHeight={false}>
          <div className="imgbox-fullwidth">
            <ImageWithBorders
              imageUrl={imageLink}
              coordinates={coords}
              className="img-viewer"
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
